import React, { useState } from 'react';
import DRP from 'react-daterange-picker';
import 'react-daterange-picker/dist/css/react-calendar.css';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import {
  CalendarWrapper, CleanButton, CloseButton, ButtonsWrapper
} from 'Common/Components/Contextualization/DateRangePicket/styled';
import { Wrapper, Value } from './styled';

const moment = extendMoment(originalMoment);

const DateRange = ({ onValueSelect }) => {
  const [value, setValue] = useState(null);
  const today = moment();

  const onSelect = (val) => {
    if (val) {
      setValue(val);
    }
  };

  const onToggle = () => {
    if (value) {
      const dateString = `${moment(value.start).format('ddd MMM D YYYY')} - ${moment(value.end).format('ddd MMM D YYYY')}`;
      onValueSelect(dateString);
    }
  };

  return (
    <Wrapper>
      <Value />
      <CalendarWrapper width={ 170 }>
        <DRP
          value={ value || moment.range(today.clone(), today.clone()) }
          onSelect={ onSelect }
          singleDateRange={ false }
          helpMessage=""
        />
        <ButtonsWrapper>
          <CleanButton onClick={ () => { setValue(null); } }>Clean</CleanButton>
          <CloseButton disabled={ !value } onClick={ onToggle }>Save</CloseButton>
        </ButtonsWrapper>
      </CalendarWrapper>
    </Wrapper>
  );
};

export default DateRange;
